export enum Translations {
  FileManagement = "fileManagement",
  UploadModal = "uploadModal",
  FileSetsModal = "fileSetsModal",
  FilePicker = "filePicker",
  ForbiddenAccess = "forbidden",
  HubExpired = "expired",
  External = "external",
  SharingCenter = "sharingCenter",
  Common = "common",
  FileTypes = "fileTypes",
  ActivityWindow = "activityWindow",
}